import styles from './MainContainer.module.scss';
import { Grid } from '@mds/web-ui-grid'
import UploadPage from '../UploadPage';
import DownloadTemplate from '../DownloadTemplate';
import ErrorDisplay from '../ErrorDisplay';
import {useState} from 'react';
import type {ClpError} from '../../types/clpTypes';

const  MainContainer = ()  => {
  const [errors, setErrors] = useState<ClpError[]>([]);

  const handleErrors = (errors: ClpError[]) => {
    setErrors(errors);
  };

  return (
    <Grid alignItems="stretch" container>
      <Grid columnSpan={{
      lg: 3,
      sm: 3
    }}>

      </Grid>
      <Grid columnSpan={{
      lg: 6,
      sm: 6
    }} container>
        <Grid columnSpan={{
      lg: 12,
      sm: 12
    }}>
      <div className={styles.mainContainer}>
        <div className={styles['margin-top']}>
        <div className={styles['font-open-sans']}>
          Check Address Eligibility for Community Lending Program
        </div>
            <DownloadTemplate onErrors={handleErrors}></DownloadTemplate>
            <ErrorDisplay errors={errors} />
            <UploadPage onErrors={handleErrors}></UploadPage>
        </div>
      </div>


        </Grid>
      </Grid>
      <Grid columnSpan={{
      lg: 3,
      sm: 3
    }}>

      </Grid>
    </Grid>
  );
}

export default MainContainer;
